import React, { useState } from 'react';
// import AdministrationIcon from '../../static/image/administrationIcon.svg';
// import RequestIcon from '../../static/image/requestApprovalIcon.svg';
import LogOutIcon from '../../static/image/logOutIcon.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/supportportalLoginSlice';
import {
  LEFT_MENU_ADMINISTRATION,
  LEFT_MENU_REQUEST_APPROVAL,
  LEFT_MENU_DIGITAL_PRICE_TAG,
  LEFT_MENU_USER_MANAGEMENT,
  LEFT_MENU_ROLE_AND_PERMISSION,
  LEFT_MENU_REQUESTER,
  LEFT_MENU_APPROVER,
  LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE,
  LEFT_MENU_SUB_UPLOAD_EXCEL_ROADSHOW,
  LEFT_MENU_EXCEL_UPLOAD_LOG,
  LEFT_MENU_SUB_UPLOAD_EXCEL_SELECTED_SHOP
} from '../../utils/constant';
import { decodedJWTPayload } from '../../utils/commonUtil';

function LeftMenu({ title, onSelect, activeMenuItem }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const icon = title === LEFT_MENU_ADMINISTRATION
  //   ? AdministrationIcon
  //   : title === LEFT_MENU_REQUEST_APPROVAL || title === LEFT_MENU_DIGITAL_PRICE_TAG
  //     ? RequestIcon
  //     : null;
  const itemClass = title === LEFT_MENU_ADMINISTRATION ? 'sidebar-item admin-item' : 'sidebar-item';

  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        navigate('/login');
        window.location.reload();
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const token = localStorage.getItem('access_token');
  const decodedToken = token ? decodedJWTPayload(token) : null;
  const mnId = decodedToken && decodedToken.mn_id ? decodedToken.mn_id : '';

  const shouldShowMenu = (menuTitle) => {
    switch (menuTitle) {
      case LEFT_MENU_ADMINISTRATION:
        return mnId.includes('010000');
      case LEFT_MENU_DIGITAL_PRICE_TAG:
        return mnId.includes('030000');
      default:
        return true;
    }
  };

  const toggleSubMenuItems = (title) => {
    switch (title) {
      case LEFT_MENU_ADMINISTRATION: {
        const subMenuItems = [];
        if (mnId.includes('010100')) subMenuItems.push(LEFT_MENU_USER_MANAGEMENT);
        if (mnId.includes('010200')) subMenuItems.push(LEFT_MENU_ROLE_AND_PERMISSION);
        return subMenuItems;
      }
      case LEFT_MENU_DIGITAL_PRICE_TAG: {
        const subMenuItems = [];
        if (mnId.includes('030100')) subMenuItems.push(LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE);
        if (mnId.includes('030200')) subMenuItems.push(LEFT_MENU_SUB_UPLOAD_EXCEL_ROADSHOW);
        if (mnId.includes('040100')) subMenuItems.push(LEFT_MENU_SUB_UPLOAD_EXCEL_SELECTED_SHOP);
        if (mnId.includes('030300')) subMenuItems.push(LEFT_MENU_EXCEL_UPLOAD_LOG);
        return subMenuItems;
      }
      case LEFT_MENU_REQUEST_APPROVAL:
        return [LEFT_MENU_REQUESTER, LEFT_MENU_APPROVER];
      default:
        return [];
    }
  };

  const subMenuItems = toggleSubMenuItems(title);

  const getTextStyle = (menuTitle) => {
    if ([LEFT_MENU_ADMINISTRATION, LEFT_MENU_REQUEST_APPROVAL, LEFT_MENU_DIGITAL_PRICE_TAG].includes(menuTitle)) {
      return {
        color: '#797E85',
        fontSize: '12px',
        fontWeight: 400
      };
    }
    if (activeMenuItem === menuTitle) {
      return {
        color: '#2C2C2C',
        fontSize: '12px',
        fontWeight: 700
      };
    }
    return {
      color: '#797E85',
      fontSize: '12px',
      fontWeight: 400
    };
  };

  if (!shouldShowMenu(title)) {
    return null;
  }

  return (
    <div>
      <div
        className={itemClass}
        onClick={() => {
          if ([LEFT_MENU_ADMINISTRATION, LEFT_MENU_REQUEST_APPROVAL, LEFT_MENU_DIGITAL_PRICE_TAG].includes(title)) {
            handleToggle();
          } else {
            onSelect(title);
          }
        }}
      >
        {/* {icon && <img src={icon} alt="" className="sidebar-icon" />} */}
        <div style={getTextStyle(title)}>{title}</div>
      </div>
      {[LEFT_MENU_ADMINISTRATION, LEFT_MENU_REQUEST_APPROVAL, LEFT_MENU_DIGITAL_PRICE_TAG].includes(title) && (
        <div className={`sub-menu ${isExpanded ? 'expanded' : 'collapsed'}`}>
          {subMenuItems.map((item, index) => (
            <div
              key={index}
              className={`sub-menu-item ${activeMenuItem === item ? 'active-sub-menu-item' : ''}`}
              onClick={() => {
                onSelect(item);
              }}
            >
              <div style={getTextStyle(item)}>{item}</div>
            </div>
          ))}
        </div>
      )}
      {title === LEFT_MENU_REQUEST_APPROVAL && <div className='ao-line'></div>}

      <div className='logout' onClick={handleLogout}>
        <img src={LogOutIcon} alt='' />
        <div style={{ marginLeft: '5px' }}>Log Out</div>
      </div>

    </div>
  );
}

export default LeftMenu;    